import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import KrispButton from '../components/KrispButton';

const ROWS = 3;

export default function SnackedToday() {
  const navigate = useNavigate();
  return (
    <section data-testid="snacked-today" className="relative bg-kyellow py-14 md:py-20 overflow-hidden rounded-t-[2.5rem]">
      <div className="space-y-1 select-none">
        {Array.from({ length: ROWS }).map((_, r) => (
          <div key={r} className="overflow-hidden">
            <div className={`marquee-track ${r % 2 ? 'marquee-rev' : ''}`} style={{ '--mq-t': `${28 + r * 6}s` }}>
              {[0, 1].map((half) => (
                <div key={half} className="flex shrink-0">
                  {Array.from({ length: 6 }).map((__, k) => (
                    <span key={k} className={`font-display text-[12vw] md:text-[7vw] leading-[0.9] px-4 whitespace-nowrap ${r % 2 ? 'stroke-text' : 'text-cocoa'}`}>
                      GO BEYOND. GO BEYOND.
                    </span>
                  ))}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <motion.div initial={{ opacity: 0, scale: 0.9 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }}
        className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="pointer-events-auto rounded-3xl bg-cream border-2 border-cocoa shadow-[8px_8px_0_#2A1010] px-8 py-7 text-center max-w-sm mx-5">
          <p className="font-display text-4xl text-cocoa leading-none">GO BEYOND WITH US.</p>
          <p className="text-sm text-cocoa/70 mt-2">50g packs are live. ₹50 each, minimum 3, delivered to your door.</p>
          <KrispButton testid="snacked-shop-now" className="mt-5" onClick={() => navigate('/products')}>SHOP NOW →</KrispButton>
        </div>
      </motion.div>
    </section>
  );
}
